import React from 'react';
import PropTypes from 'prop-types';
import { FacilitiesList } from '@lt/components';
import { useTranslation } from '@lt/localization';

import styles from './tooltipContent.module.css';

const RoomFacilities = ({ items }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className={styles.facilitiesTitle}>
        {t('hotel.facilities.hasRooms')}
      </div>
      <FacilitiesList
        className={styles.facilitiesList}
        items={items}
        showItemCheck
        inColumns
      />
    </div>
  );
};

RoomFacilities.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      best: PropTypes.bool,
    }).isRequired,
  ).isRequired,
};

export default RoomFacilities;
